import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { replaceAnimationPath } from '../../../lib/media-path-replacer';
import Accordion from '../../accordion';
import { Body } from '../../typography';
import AnimationContainer from '../animation-container';

const Container = styled.div`
    padding-bottom: 16px;

    & > div:not(:last-child) {
        margin-bottom: 8px;
    }
`;

const DEFAULT_TITLE = 'Animazione';

export const parseAnimations = (animations) => {
    const parser = new DOMParser();

    const result = [];

    for (let i = 0; i < animations.length; i++) {
        const currentAnimation = animations[i].xml;
        const document = parser.parseFromString(currentAnimation, 'application/xml');
        const parsedPublicTitle = document.getElementsByTagName('public_title')[0];

        let publicTitle;
        if (parsedPublicTitle && parsedPublicTitle.textContent) {
            publicTitle = parsedPublicTitle.textContent;
        } else {
            publicTitle = `${DEFAULT_TITLE} ${i + 1}`;
        }

        const parsedSrc = document.getElementsByTagName('src')[0].textContent;
        const contentSrc = replaceAnimationPath(parsedSrc);

        result.push({ title: publicTitle, contentSrc: contentSrc });
    }

    return result;
};

const AnimationType = ({ animations }) => {
    const parsedAnimations = parseAnimations(animations);

    return (
        <Container>
            {parsedAnimations.map((a, index) => {
                return (
                    <Accordion key={index}>
                        <Body lv={4} fontWeight="semi-bold">
                            {a.title}
                        </Body>
                        <AnimationContainer src={a.contentSrc} title={`Animazione ${index + 1}`} />
                    </Accordion>
                );
            })}
        </Container>
    );
};

AnimationType.propTypes = {
    animations: PropTypes.array,
};

export default AnimationType;
